import { temAcesso } from '@/shared/auth/temAcesso'

const ResumoAtendentes = () => import('./ResumoAtendentes.vue')
// const ResumoAtendentesDetalhar = () => import('./ResumoAtendentesDetalhar.vue')

export default {
    path: 'resumoatendentes',
    name: 'ResumoAtendentes',
    component: ResumoAtendentes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-USR-00') && temAcesso('MENSAGENS-01')) {
            next()
        }
    },
    // children: [
    //     {
    //         path: 'detalhar/:usuarioId',
    //         name: 'ResumoAtendentes_Detalhar',
    //         component: ResumoAtendentesDetalhar,
    //         beforeEnter: (to, from, next) => {
    //             if (temAcesso('MENSAGENS-00')) {
    //                 next()
    //             }
    //         }
    //     }
    // ]
}